var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromotionCustomize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18136_78267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 17.0632C12.4434 17.0632 12.803 16.7037 12.803 16.2601C12.803 15.8166 12.4434 15.457 11.9999 15.457C11.5563 15.457 11.1968 15.8166 11.1968 16.2601C11.1968 16.7037 11.5563 17.0632 11.9999 17.0632Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 8.54274C12.4434 8.54274 12.803 8.18318 12.803 7.73963C12.803 7.29609 12.4434 6.93652 11.9999 6.93652C11.5563 6.93652 11.1968 7.29609 11.1968 7.73963C11.1968 8.18318 11.5563 8.54274 11.9999 8.54274Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.353 0.647578C22.936 0.229969 22.3811 0 21.7906 0H13.3771C12.7869 0 12.232 0.229875 11.8147 0.647297L0.647391 11.8146C0.229875 12.232 0 12.7869 0 13.377C0 13.9671 0.229969 14.522 0.647391 14.9391L9.0607 23.3525C9.47798 23.77 10.0328 24 10.623 24C11.2131 24 11.768 23.7701 12.1854 23.3526L23.3527 12.1853C23.7701 11.768 24 11.2131 24 10.6229V2.20936C24 1.61888 23.77 1.06397 23.353 0.647578ZM12 5.53017C13.2183 5.53017 14.2094 6.5213 14.2094 7.73953C14.2094 8.95777 13.2183 9.94889 12 9.94889C10.7818 9.94889 9.79069 8.95777 9.79069 7.73953C9.79069 6.5213 10.7818 5.53017 12 5.53017ZM12 18.4697C10.7818 18.4697 9.79069 17.4786 9.79069 16.2604C9.79069 15.0421 10.7818 14.051 12 14.051C13.2183 14.051 14.2094 15.0421 14.2094 16.2604C14.2094 17.4786 13.2183 18.4697 12 18.4697ZM16.5187 12.7031H7.48134C7.09303 12.7031 6.77822 12.3883 6.77822 12C6.77822 11.6116 7.09303 11.2968 7.48134 11.2968H16.5187C16.9071 11.2968 17.2219 11.6116 17.2219 12C17.2219 12.3883 16.9071 12.7031 16.5187 12.7031ZM19.5313 5.17186C19.1431 5.17186 18.8281 4.85686 18.8281 4.46873C18.8281 4.08061 19.1431 3.76561 19.5313 3.76561C19.9194 3.76561 20.2344 4.08061 20.2344 4.46873C20.2344 4.85686 19.9194 5.17186 19.5313 5.17186Z",
    fill: "#50429B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18136_78267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionCustomize);
export default __webpack_public_path__ + "static/media/promotion-customize.7d051cf47d6e2c998f2809452d697c31.svg";
export { ForwardRef as ReactComponent };